import { useClientLogger } from '@coolblue-development/next-config/client';
import { getAllSelectedInstallationServices } from '@coolblue-development/next-installation-services/client';
import { addSecondChanceProductsToMandy } from '@coolblue-development/next-shopping-cart/actions';
import { addProductToShoppingCart } from '@utils/nextShoppingCartActions/addProductToShoppingCart';

import { ShoppingCartData, TradeInType } from './types';

export const onSubmitForm = async (
  formElement: HTMLFormElement,
  tradeIn: TradeInType,
  trackingEvent: () => void,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  productId: number,
  quantity: number,
  logger: ReturnType<typeof useClientLogger>,
  secondChanceProductId?: string,
  secondChanceRedirectUrl?: string
) => {
  const formData = new FormData(formElement);

  const installationServices = getAllSelectedInstallationServices(formData);
  const installationServiceProductIds = installationServices.map(service => service.productId);
  const installationServiceAccessory = installationServices
    .map(service => Number(service.accessoryId))
    .find(id => id > 0); // In the legacy shopping cart only one accessory is supported

  const accessoryPromotion = formData.getAll('accessoryPromotion')[0]?.toString();
  const tradeInValue = tradeIn.brandId > 0 ? tradeIn : undefined;

  const shoppingCartData: ShoppingCartData = {};

  if (installationServices.length) {
    shoppingCartData.installationServices = installationServiceProductIds;
  }

  if (installationServiceAccessory) {
    shoppingCartData.installationServiceAccessory = installationServiceAccessory;
  }

  if (accessoryPromotion) {
    shoppingCartData.accessoryPromotionProductId = +accessoryPromotion;
  }

  if (tradeInValue) {
    shoppingCartData.tradeIn = tradeInValue;
  }

  if (quantity > 1) {
    shoppingCartData.quantity = quantity;
  }

  if (secondChanceProductId) {
    await addSecondChanceProductsToMandy({
      products: [
        {
          productId: secondChanceProductId.toString(),
          installationServices: installationServices
        }
      ]
    })
      .then(() => {
        trackingEvent();

        if (secondChanceRedirectUrl) {
          window.location.assign(secondChanceRedirectUrl);
          return;
        }

        setIsLoading(false);
      })
      .catch(error => {
        logger.error(`Failed to add second-chance-product to shopping cart`, error);

        setIsLoading(false);
      });
  } else {
    await addProductToShoppingCart({
      productId: productId,
      params: shoppingCartData,
      revalidate: false
    })
      .then(response => {
        trackingEvent();

        const redirectUrl = response?.data?.redirectUrl;

        if (redirectUrl) {
          window.location.assign(redirectUrl);
          return;
        }

        setIsLoading(false);
      })
      .catch(error => {
        logger.error(`Failed to add product to shopping cart`, error);

        setIsLoading(false);
      });
  }
};
